export const validPhoneNumberPattern =
  /^[+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/g;

export const validatePhoneNumberRegex = (phoneNumber: string) =>
  phoneNumber && phoneNumber.match(validPhoneNumberPattern);
